import { DurationInputArg1, DurationInputArg2 } from 'moment';
import { RequestEvent } from './utils/observers/RequestObserver';
import {
  parseEnvNumber,
  parseEnvNumberArray,
  parseEnvStringArray,
} from './utils/env';

type TimeDelta = [DurationInputArg1, DurationInputArg2];

export const IMAGE_TIMEOUT = 30_000;
export const MANAGEMENT_PAGE_SIZE = 10;
export const ORDENABLE_PAGE_SIZE = 100;
export const TIME_RELEASE_LINK_SCHEDULED_LESSON_MS = 30 * 60 * 1000; // 30min
export const DEFAULT_KLASS_DURATION_IN_MINUTES = 90;
export const REQUEST_STALE_TIME_IN_MS = 20 * 60 * 1000; // 20min;
export const REQUEST_STALE_TIME_1_DAY_IN_MS = 24 * 60 * 60 * 1000; // 24h;
export const MAX_PROJECT_VIDEO_SIZE = 500 * 1024 * 1024; // 500mb
export const MAX_PROMPT_FILES_SIZE = 300 * 1024 * 1024; // 300mb
export const MAX_QUIZ_ANSWERS_FILE_SIZE = 10 * 1024 * 1024; // 10mb
export const QUIZ_ANSWERS_ACCEPTED_IMAGE_TYPES = '.png,.jpg,.jpeg,.gif,.webp';
export const MAX_PROMPT_FILES_COUNT = 10;
export const GRADE_CONDITION_FOR_TROPHY = 0.5;
export const MINUTES_OPTIONS = [0, 15, 30, 45];
export const ACTIVE_LESSON_TAB_STORAGE_KEY = 'astro/activelessontab';
export const REQUEST_AUTOSAVE_CHAPTER_TIME_IN_MS = 10 * 60 * 1000; // 10min;
export const STAFF_CURRENT_QUESTION = 'staffCurrentQuestion';
export type REWARD_TRIGGER_EVENT = Omit<RequestEvent, 'url'> & { url: RegExp };
export const REWARDS_TRIGGER_EVENTS: REWARD_TRIGGER_EVENT[] = [
  {
    method: 'delete',
    statusCode: 204,
    url: /projects/g,
  },
  {
    method: 'patch',
    statusCode: 200,
    url: /homework-progress/g,
  },
  {
    method: 'post',
    statusCode: 201,
    url: /activity-progress-attempt/g,
  },
  {
    method: 'patch',
    statusCode: 200,
    url: /chapter-progress/g,
  },
  {
    method: 'patch',
    statusCode: 200,
    url: /^activity-progress/,
  },
  {
    method: 'post',
    statusCode: 201,
    url: /shop\/purchase/,
  },
];

export const USER_INFO_COOKIE_KEY = 'user_info';
export const CSRF_COOKIE_KEY = 'csrftoken';

export const FORCED_LOGOUT_STORAGE_KEY = 'forced_logout_version';
export const FORCED_LOGOUT_VERSION = 'aws-cookie-domain-migration';

export const USER_SETTINGS = 'user_settings';
export const APP_SHELL_SIDEBAR_STORAGE_KEY = 'app-shell-sidebar';
export const UPDATES_SETTINGS = 'updates_settings';
export const TRANSFORM_KEYS_PAYLOAD_IGNORE = ['map', 'teacherCode', 'blocks'];
export const TRANSFORM_KEYS_PAYLOAD_PRESERVE = ['pt-br'];
export const HIDDEN_COMPONENTS_SETTINGS = 'hidden_components_settings';
export const UPDATES_ENDTIME: TimeDelta = [3, 'months'];
export const RANKING_TIME: TimeDelta = [1, 'weeks'];
export const TIME_REFRESH_NOTIFICATIONS = 10000; // 10sec
export const DEFAULT_TIMEZONE = 'America/Sao_Paulo';
export const INTERVAL_BETWEEN_SOUND_ALERTS = 20000; //20sec
export const ASTRO_CODE_EDITOR_THEME = 'astroCodeEditorTheme';
export const MULTIPART_FORM_DATA_HEADERS = {
  'Content-Type': 'multipart/form-data',
  accept: 'application/json',
};
export const GRID_ROW_HEIGHT = 10;

export const NEW_UI_FLAG = 'astro-new-ui';

export const ASTRO_AI_MAX_TOKEN_BALANCE = parseEnvNumber(
  process.env.VITE_ASTRO_AI_MAX_TOKEN_BALANCE,
  50,
);

export const LESSON_BLOCKS_LIMIT = 20;
export const ASTRO_AI_UNITS_ENABLED = parseEnvNumberArray(
  process.env.VITE_ASTRO_AI_UNITS_ENABLED,
);
export const LESSON_INTO_BLOCK_MAX_PAGE_SIZE = 50;

export const ASTRO_AI_COURSEPATHSLUGS_ENABLED = parseEnvStringArray(
  process.env.VITE_ASTRO_AI_COURSEPATHSLUGS_ENABLED,
);

export const MILLISECONDS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;

export const MILLISECONDS_PER_MINUTE =
  MILLISECONDS_PER_SECOND * SECONDS_PER_MINUTE;
export const MILLISECONDS_PER_HOUR = MILLISECONDS_PER_MINUTE * MINUTES_PER_HOUR;
export const MILLISECONDS_PER_DAY = MILLISECONDS_PER_HOUR * HOURS_PER_DAY;

export const LINE_NAME_MAP = {
  ctrlKids: 'Ctrl+Kids',
  ctrlTeens: 'Ctrl+Teens',
  ctrlYoung: 'Ctrl+Young',
  ctrlQuick: 'Ctrl+Quick',
  ctrlPro: 'Ctrl+Pro',
};

export const GROWTHBOOK_TIMEOUT = 2000;
